import {z} from 'zod'

import {FormValidationInput} from '../../../types'
import {ErrorCodes} from '../../common/validation/errorCodes'
import {PlusLoadConfiguration, PlusLoadForm} from '../types'

/**
 * Validates that the plusLoad field is set when needed
 */
export const validatePlusLoad = (
  data: Partial<PlusLoadForm>,
  ctx: z.RefinementCtx,
  {
    configuration: {plusLoadExpected: plusLoadConfiguration}
  }: FormValidationInput<PlusLoadConfiguration>
) => {
  // Skip validation if plus load feature is not enabled
  if (!plusLoadConfiguration.enabled) {
    return
  }

  // If plus load is required but not set, add validation error
  if (plusLoadConfiguration.enabled && data.plusLoadExpected === undefined) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['plusLoadExpected'],
      message: ErrorCodes.plusLoad.required
    })
  }
}
